import { css } from "@emotion/react";
import { FC } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { withVar } from "themes/helpers";

import { textMuted, textSmall } from "../styled/typography";

const container = css`
  position: relative;
  display: flex;
  flex-direction: row;
  height: 35px;
`;

const navButton = css`
  flex: 0 0 24px;
  border: none;
  background: none;

  &:focus:enabled svg,
  &:hover:enabled svg {
    fill: ${withVar(DesignToken.ActionPrimaryDefault)};
  }

  &:disabled {
    opacity: 0.3;
  }
`;

const chevronLeft = css`
  transform: rotate(90deg) scale(0.75);
`;

const chevronRight = css`
  transform: rotate(-90deg) scale(0.75);
`;

const ticks = css`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 auto;
`;

const tick = css`
  flex-grow: 0;
`;

const timeTicks = ["12 AM", "4 AM", "8 AM", "12 PM", "4 PM", "8 PM", "12 AM"];

interface IProps {
  onNext(): void;
  onPrev(): void;
  disabledPrev?: boolean;
  disabledNext?: boolean;
}

export const AgentActivityNavigation: FC<IProps> = ({ onNext, onPrev, disabledPrev, disabledNext }) => {
  return (
    <div css={container}>
      <button css={navButton} disabled={disabledPrev} type="button" onClick={onPrev}>
        <Icon name={IconsEnum.ChevronDown} css={chevronLeft} fill={withVar(DesignToken.ContentBasicPrimary)} />
      </button>
      <div css={ticks}>
        {timeTicks.map((timeTick, index) => (
          <div css={[tick, textSmall, textMuted]} key={index}>
            {timeTick}
          </div>
        ))}
      </div>
      <button css={navButton} disabled={disabledNext} type="button" onClick={onNext}>
        <Icon name={IconsEnum.ChevronDown} css={chevronRight} fill={withVar(DesignToken.ContentBasicPrimary)} />
      </button>
    </div>
  );
};
